export default {
    props: {
        socials: {}
    },
    name: 'course-sidebar-social',
}
